import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import { Context } from '../../context/UserContext';
import InputMask from 'react-input-mask';
import Pagination from '../Common/Pagination';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';

const Index = () => {

    const context = useContext(Context);
    const { readData } = useEntityCrud("Advertisements/getAllAdvertisement")
    const { addData: updateData } = useEntityCrud('Advertisements/changeStatusAdvertisement');

    const [title,setTitle] = useState('');
    const [fromDate,setFromDate] = useState('');
    const [toDate,setToDate] = useState('');

    const [list, setList] = useState([])

    const [lastPage,setLastPage] = useState(0);
    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [count,setCount] = useState(0);

    const convertToGregorian = date => `${date.year.toString()}/${(date.month > 9 ? date.month.toString() : ('0' + date.month))}/${(date.day > 9 ? date.day.toString() : ('0' + date.day))}`

    useEffect(() => {
        getData();
    }, [])

    const getData = () => {
        const postedData = {
            offset: 0,
            limit: 10
        };
        if(title)
            postedData.title = title;
        if(fromDate)
            postedData.fromDate = convertToGregorian(fromDate);
        if(toDate)
            postedData.toDate = convertToGregorian(toDate);
        readData(postedData).then(res => {
            setList(res.data.result)
            calcPages(res)
        })
    }

    const resetFilters = () => {
        setTitle('');
        setFromDate('');
        setToDate('');
        readData({offset: 0,limit: 10}).then(res => {
            setList(res.data.result)
            calcPages(res)
        });
    }

    function convertDateToInputValue(date) {
        if (!date) return "";
        const shamsiDate = new Date(date).toLocaleDateString("fa-ir-u-nu-latn", {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        });
        return shamsiDate
    }


    const deActiveRow = item => {
         
        document.getElementById(`btn-submit-form${item.id}`).classList.add('btn-loading');

        const postedData = {
            "id": item.id,
            "expireDate": item.expireDate,
            "fromDate": item.fromDate,
            "title": item.title,
            "image": item.image,
            "insertDate": "2023-08-09T06:29:58.028Z",
            "confirmDate": "2023-08-09T06:29:58.028Z",
            "insertUser": 0,
            "confirmUser": 0,
            "status": false,
        };
        updateData(postedData).then(({ data }) => {
             
            if (data.status) {
                toast.success('وضعیت تبلیغ مورد نظر با موفقیت به روزرسانی شد');
                getData();
            } else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById(`btn-submit-form${item.id}`).classList.remove('btn-loading'));;
    }

    const activeRow = item => {
         
        document.getElementById(`btn-submit-form${item.id}`).classList.add('btn-loading');
        const postedData = {
            "id": item.id,
            "expireDate": item.expireDate,
            "fromDate": item.fromDate,
            "title": item.title,
            "image": item.image,
            "insertDate": "2023-08-09T06:29:58.028Z",
            "confirmDate": "2023-08-09T06:29:58.028Z",
            "insertUser": 0,
            "confirmUser": 0,
            "status": true,
        };
        updateData(postedData).then(({ data }) => {
             
            if (data.status) {
                toast.success('وضعیت تبلیغ مورد نظر با موفقیت به روزرسانی شد');
                getData();
            } else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById(`btn-submit-form${item.id}`).classList.remove('btn-loading'));;
    }

    const calcPages = res => {
        let calcPages = res.data.count / 10;
        setCount(res.data.count)
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setLastPage(pagesArray.length)
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
        const postedData = {
            limit: 10,
            offset: page - 1
        };
        readData(postedData).then(res => {
            setList(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const prevPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        const postedData = {
            limit: 10,
            offset: currentPage - 2
        };
        readData(postedData).then(res => {
            setList(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const nextPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage + 1);
        const postedData = {
            limit: 10,
            offset: currentPage
        };
        readData(postedData).then(res => {
            setList(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">   تبلیغات </div>
            </div>
            <div className="card-body">
                <Link to="/advertiseList/create" className="btn btn-primary mb-3 me-2 accordion-toggle collapsed" aria-expanded="false">ایجاد</Link>
                <button className="btn btn-dark mb-3 accordion-toggle collapsed" data-bs-toggle="collapse" href="#filter" aria-expanded="false">جستجو</button>
                <div id="filter" className="panel-collapse collapse position-relative" role="tabpanel" aria-expanded="false">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label> عنوان </label>
                                <input className="form-control" placeholder="عنوان" value={title} onChange={(e) => setTitle(e.target.value)} />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label>از تاریخ</label>
                                {fromDate && <i class="fe fe-x clear-select-btn" onClick={() => setFromDate(null)} style={{left: 25}}></i>}
                                <DatePicker
                                    locale="fa"
                                    shouldHighlightWeekends
                                    value={fromDate}
                                    onChange={setFromDate}
                                    className="form-control my-1 pb-4"
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label>تا تاریخ</label>
                                {toDate && <i class="fe fe-x clear-select-btn" onClick={() => setToDate(null)} style={{left: 25}}></i>}
                                <DatePicker
                                    locale="fa"
                                    shouldHighlightWeekends
                                    value={toDate}
                                    onChange={setToDate}
                                    className="form-control my-1 pb-4"
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <button className="btn btn-primary me-2" onClick={getData} style={{marginTop: 30}}>جستجو</button>
                            {title || fromDate || toDate ? <button className="btn btn-danger" onClick={resetFilters} style={{marginTop: 30}}>بازنشانی</button> : ''}
                        </div>
                    </div>
                </div>
                {list?.length ? <div className="table-responsive"><table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            <th>از تاریخ   </th>
                            <th>تا تاریخ   </th>
                            <th>  وضعیت </th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list?.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.title}</td>
                                <td>{convertDateToInputValue(item.fromDate) || "-"}</td>
                                <td>{convertDateToInputValue(item.expireDate)}</td>
                                <td>{item.status === false ? "رد شده" : item.status === true ? "تایید شده " : "در دست بررسی "}</td>
                                <td className="btn-list">
                                    {context.checkHasPermission('update') ? <Link to={'update/' + item.id} className="btn btn-icon mb-0 btn-primary" title="ویرایش"><i className="fe fe-edit-2"></i></Link> : ''}
                                    {context.checkHasPermission('update') && item.status !== true ? <button onClick={e => activeRow(item)} className="btn btn-icon mb-0 btn-success " id={`btn-submit-form${item.id}`}><i className="fe fe-check"></i> تایید   </button> : ""}
                                    {context.checkHasPermission('update') && item.status !== false ? <button onClick={e => deActiveRow(item)} className="btn btn-icon mb-0 btn-danger " id={`btn-submit-form${item.id}`}><i className="fe fe-x"></i> عدم تایید </button> : ""}

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <p>تعداد کل ردیف ها : {list.length}</p>
                <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} lastPage={lastPage} />
                </div> : <div className="alert alert-info"><p>تبلیغاتی یافت نشد</p></div>}
            </div>
        </div>
    );
}

export default Index;